/**
 * 配送依頼 汎用CSVインポート（#4728）のウィザード状態モデル。
 */

/** ウィザードのビュー（状態機械） */
export type CsvImportView = 'method' | 'mapping' | 'preview' | 'done'

/**
 * 取り込み方法（モーダル最初の3択）。
 * - standard: 通常フォーマットを使う（ロジGo標準フォーマット。マッピング画面なし）
 * - saved: 保存したフォーマットを使う（マッピング画面の初期値をテンプレートで埋める。読み込み後も修正可）
 * - adhoc: フォーマット外のものを取り込む（マッピング画面に白紙で入る）
 *
 * saved / adhoc は別フローではなく、同じマッピング画面に入るときの初期状態の違いだけ。
 * 保存フォーマットは紐づけ作業を簡略化する初期値の供給源であって、画面を飛ばすショートカットではない。
 */
export type ImportMethod = 'standard' | 'saved' | 'adhoc'

/**
 * パース済みのCSV生データ。
 * - rows: papaparse でパースした2次元配列（全行 × 全列、ヘッダー含む生の行）。
 * - fileName / rowCount / columnCount: プレビュー表示・サマリ用。
 */
export type ParsedCsv = {
  fileName: string
  /** 生の行列（先頭から全行）。各行は文字列セルの配列。 */
  rows: string[][]
  rowCount: number
  columnCount: number
  /** encoding-japanese が判定した文字コード（表示用、例: 'UTF-8' / 'Shift_JIS'）。 */
  encoding: string
  /**
   * 読み込みに使った文字コード（encoding-japanese の識別子、例: 'UTF8' / 'SJIS'）。
   * 取り込み時にサーバーへ渡し、画面と同じ文字コードで読ませる（行番号・値をずらさないため）。
   */
  encodingCode: string
}

/**
 * ステップ1で指定する「読み取り開始」の設定。
 * - hasHeader: 1行目（正確には headerRowNo 行目）が項目名かどうか。
 * - headerRowNo: ヘッダー行の行番号（1始まり）。hasHeader=false のときは無視。
 * - startRowNo: データ開始行の行番号（1始まり）。これより前の行はスキップ。
 * - startColNo: 開始列の列番号（1始まり・追加要件）。これより前の列はスキップ。
 *               開始列を変えると、ヘッダー判定も開始列起点にズレる（単に読み取り開始位置を決めるだけ）。
 */
export type CsvReadConfig = {
  hasHeader: boolean
  headerRowNo: number
  startRowNo: number
  startColNo: number
}

export const initialCsvReadConfig: CsvReadConfig = {
  hasHeader: true,
  headerRowNo: 1,
  startRowNo: 2,
  startColNo: 1
}

/**
 * 開始行・開始列を反映した「実効テーブル」。
 * step2 以降のマッピングはこの実効テーブルの列・行を参照する。
 * - headers: ヘッダー行（hasHeader のとき）。開始列以降のみ。ヘッダー無しのときは空配列。
 * - dataRows: データ開始行以降のデータ（開始列以降のみ）。
 * - columnCount: 実効列数（開始列以降の列数）。
 */
export type EffectiveTable = {
  headers: string[]
  dataRows: string[][]
  columnCount: number
}
